export enum TextOverPosition {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
  CENTER_RIGHT = 'center-right',
  CENTER_LEFT = 'center-left',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left',
}
